import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

/**
 * Processus de service — le catalogue de ce que l'entreprise sait faire, et les
 * dossiers en cours (ADR-015).
 *
 * `noCache` partout : un dossier avance à plusieurs mains, une vue gardée en
 * cache montrerait des étapes réglées entre-temps par quelqu'un d'autre.
 */
const processusRoutes = {
    path: "/processus",
    name: "processus-root",
    component: Layout,
    redirect: "/processus/dossiers",
    alwaysShow: true,
    meta: {
        title: "Processus",
        icon: "mdi:sitemap-outline",
        permissions: [P.PROCESSUS.BROWSE]
    },
    children: [
        {
            path: "dossiers",
            name: "processus-dossiers",
            meta: {
                title: "Dossiers",
                icon: "mdi:clipboard-text-outline",
                permissions: [P.PROCESSUS.BROWSE],
                noCache: true
            },
            component: () => import("@/views/processus/Dossiers.vue")
        },
        {
            // Ouvert depuis la liste : pas d'entrée de menu propre.
            path: "dossiers/:id",
            name: "processus-dossier",
            hidden: true,
            meta: {
                title: "Dossier",
                permissions: [P.PROCESSUS.BROWSE],
                noCache: true,
                activeMenu: "/processus/dossiers"
            },
            component: () => import("@/views/processus/DossierDetail.vue")
        },
        {
            path: "modeles",
            name: "processus-modeles",
            meta: {
                title: "Modèles",
                icon: "mdi:file-tree-outline",
                permissions: [P.PROCESSUS.ADMIN],
                noCache: true
            },
            component: () => import("@/views/processus/Modeles.vue")
        }
    ]
};

export default processusRoutes;
